import PropTypes from 'prop-types';
import { useState } from 'react';
import Text from 'atoms/Text';
import { IN_SCOPE_COMMANDS } from 'lib/commandFormatRegistry';

// `ALL` + one pill per in-scope command. Single-select, `ALL` default.
// Collapsed by default behind `+ more` / `− less` (Story §5).
const COLLAPSED_COUNT = 3;
const ALL = 'ALL';

const Pill = ({ label, active, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className={`px-2 py-0.5 rounded text-xs font-semibold border transition-colors ${
            active
                ? 'bg-success-500/15 border-success-500 text-success-500'
                : 'border-gray-600 text-gray-200 hover:border-success-500'
        }`}
    >
        {label}
    </button>
);

Pill.propTypes = {
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
    onClick: PropTypes.func.isRequired
};

const CommandFilterPills = ({ active, onChange }) => {
    const [expanded, setExpanded] = useState(false);

    const pills = [ALL, ...IN_SCOPE_COMMANDS];
    const visible = expanded ? pills : pills.slice(0, COLLAPSED_COUNT + 1);

    return (
        <div className="flex flex-wrap gap-1.5">
            {visible.map((label) => (
                <Pill
                    key={label}
                    label={label}
                    active={active === label}
                    onClick={() => onChange(label)}
                />
            ))}
            <button
                type="button"
                onClick={() => setExpanded((v) => !v)}
                className="px-1 text-xs text-success-500 font-semibold"
            >
                <Text variant="small" className="text-success-500" fontWeight="font-semibold">
                    {expanded ? '− less' : '+ more'}
                </Text>
            </button>
        </div>
    );
};

CommandFilterPills.propTypes = {
    active: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

CommandFilterPills.defaultProps = {
    active: ALL
};

export default CommandFilterPills;
export { ALL };
